<script>
import { mapActions } from 'vuex'
import amountMask from '@lib/utils/amount-mask'
import { datePickerFormat } from '@lib/utils/date-helper'
import ValidationMixin from '@lib/mixins/validation'

export default {
  name: 'PaymentEdit',
  mixins: [ValidationMixin],
  props: {
    payment: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      datePickerFormat,
      submitting: false,
      form: {},
      rules: {
        cashOutLimit: [
          {
            required: true,
            message: 'This field is required',
          },
        ],
      },
    }
  },
  created() {
    this.form = {
      ...this.payment,
    }
  },
  methods: {
    ...mapActions('settings', [
      'updateSettings',
    ]),
    amountMask,
    onChange(field, value) {
      this.form[field] = value
      delete this.backendErrors[field]
      this.$refs.form.validateField(field)
    },
    onCancel() {
      this.form = this.payment
      this.$emit('cancel')
    },
    async onSubmit() {
      this.clearBackendErrors()
      const formValid = await this.$refs.form.validate().catch(() => false)
      if (!formValid) return

      this.submitting = true

      this.form.cashOutLimit = parseFloat(this.form.cashOutLimit)

      const [error, data] = await this.updateSettings(this.form)

      if (!error) {
        this.$emit('submit', data)
      } else {
        this.processBackendErrors(error)
        console.error(error)
      }

      this.submitting = false
    },
  },
}
</script>

<template>
  <data-box
    header="eWallet cash out rules"
    :status="null"
  >
    <el-form
      ref="form"
      :model="form"
      :rules="rules"
      label-position="left"
      class="card-form"
    >
      <el-form-item
        label="Minimum Amount"
        prop="cashOutLimit"
        :error="backendErrors.cashOutLimit"
        :class="$style.formItem"
      >
        <el-input
          v-model="form.cashOutLimit"
          :class="$style.input"
          @input="onChange('cashOutLimit', amountMask($event))"
        >
          <template #prepend>
            $
          </template>
        </el-input>
      </el-form-item>
    </el-form>
    <div>
      <el-button
        :class="$style.button"
        @click="onCancel"
      >
        Cancel
      </el-button>
      <el-button
        type="primary"
        :class="$style.button"
        :loading="submitting"
        @click="onSubmit"
      >
        Save
      </el-button>
    </div>
  </data-box>
</template>

<style lang="scss" module>
.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.button {
  padding-right: rem(50px);
  padding-left: rem(50px);
}

.input {
  :global {
    .el-input__inner {
      padding-left: rem(24px);
    }
  }
}

.formItem {
  label {
    margin-top: rem(8px);
  }
}

.prefix {
  padding-right: 0;
  padding-left: rem(10px);
}
</style>
